/**
 * Cost centers owned by xVT. Rows in these cost centers are read-only in the HDW Forecast Input tab
 * (they are edited only in the xVT Planning tab and land in HDW via Sync). Shared across features:
 * `xvt-planning` re-exports this, and `forecast-template` imports it directly, so there is one list
 * and no cross-feature import (per the CLAUDE separation-of-concerns rule).
 */
export const XVT_COST_CENTERS: string[] = ['7802', '7113'];
